import { render, staticRenderFns } from "./fixedAssetsCost.vue?vue&type=template&id=4bbeafa0&scoped=true&"
import script from "./fixedAssetsCost.vue?vue&type=script&lang=js&"
export * from "./fixedAssetsCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbeafa0",
  null
  
)

export default component.exports